import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Layout
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import FloatingActions from './components/common/FloatingActions';

// Pages
import Home from './pages/Home';
import Volunteer from './pages/Volunteer';
import HelpRequest from './pages/HelpRequest';
import Donate from './pages/Donate';
import Events from './pages/Events';
import EventDetails from './pages/EventDetails';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminVolunteers from './pages/admin/AdminVolunteers';
import AdminHelpRequests from './pages/admin/AdminHelpRequests';
import AdminDonations from './pages/admin/AdminDonations';
import AdminEvents from './pages/admin/AdminEvents';
import AdminSocial from './pages/admin/AdminSocial';

// Context
import { AuthProvider } from './context/AuthContext';

// Protected Route
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="flex flex-col min-h-screen bg-gray-50">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/volunteer" element={<Volunteer />} />
              <Route path="/help" element={<HelpRequest />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:id" element={<EventDetails />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />

              {/* Auth Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />

              {/* Protected Routes */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              {/* Admin Routes */}
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/volunteers"
                element={
                  <AdminRoute>
                    <AdminVolunteers />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/help-requests"
                element={
                  <AdminRoute>
                    <AdminHelpRequests />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/donations"
                element={
                  <AdminRoute>
                    <AdminDonations />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/events"
                element={
                  <AdminRoute>
                    <AdminEvents />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/social"
                element={
                  <AdminRoute>
                    <AdminSocial />
                  </AdminRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
          <FloatingActions />
          <ToastContainer position="top-right" autoClose={3000} />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;